<template>
    <div>
        <div class="card">
			<div class="card__header">
				<h4 class="card__title">Dice</h4>
			</div>
            <div class="card__body">
                <div class="dice">
                    <div class="dice__col">
						<h5 v-if="isMob" class="dice__result">{{ result }}</h5>
						<p v-if="isMob" class="dice__result-subtitle">Возможный выигрыш</p>
						<div class="dice__controls">
							<div class="dice__control">
								<div class="dice__control-label">Cумма:</div>
								<div class="game-controls">
									<div class="game-controls__bet">
										<input
											v-model="bet"
											type="number"
											@keyup="validateBet"
											class="game-controls__input"
											placeholder="Сумма"
											autocomplete="off">
									</div>
									<div class="game-controls__items">
										<button type="button" @click="typeBet('max')" class="game-controls__item">Max</button>
										<button type="button" @click="typeBet('min')" class="game-controls__item">Min</button>
										<button type="button" @click="typeBet('x2')" class="game-controls__item">x2</button>
										<button type="button" @click="typeBet('/2')" class="game-controls__item">/2</button>
									</div>
								</div>
							</div>
							<div class="dice__control">
								<div class="dice__control-label">Шанс:</div>
								<div class="game-controls">
									<div class="game-controls__bet">
										<input
											v-model="chance"
											type="number"
											@keyup="validateChance"
											class="game-controls__input"
											placeholder="Шанс"
											autocomplete="off">
									</div>
									<div class="game-controls__items">
										<button type="button" @click="typeChance('max')" class="game-controls__item">Max</button>
										<button type="button" @click="typeChance('min')" class="game-controls__item">Min</button>
										<button type="button" @click="typeChance('x2')" class="game-controls__item">x2</button>
										<button type="button" @click="typeChance('/2')" class="game-controls__item">/2</button>
									</div>
								</div>
							</div>
						</div>
                    </div>
                    <div class="dice__col">
						<h4 v-if="!isMob" class="dice__result">{{ result }}</h4>
						<p v-if="!isMob" class="dice__result-subtitle">Возможный выигрыш</p>
						<div class="dice__controls">
							<div class="dice__control">
								<p class="dice__control-title">0 - {{ min }}</p>
								<button @click="betDiceSocket('min')" :disabled="disableBtn" class="dice__action btn btn--secondary btn--block">Меньше</button>
							</div>
							<div class="dice__control">
								<p class="dice__control-title">{{ max }} - 999999</p>
								<button @click="betDiceSocket('max')" :disabled="disableBtn" class="dice__action btn btn--secondary btn--block">Больше</button>
							</div>
						</div>
                        <div class="dice__actions">
							<Loader class="dice__actions-loader" v-if="disableBtn && !success.show && !errors.show" :loading="true"/>
                            <button v-if="success.show" class="dice__action btn btn--block btn--success">
                                {{ success.message }}
                            </button>
                            <button v-if="errors.show" class="dice__action btn btn--block btn--danger">
                                {{ errors.message }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AllHistory />
    </div>
</template>

<script>
    import AllHistory from "../../components/History/AllHistory.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import Loader from "../../components/blocks/Loader.vue";

    export default {
        components: {
			Loader,
            AllHistory
        },

		mixins: [
			breakpointsMixin
		],

        data() {
            return {
                bet: 1,
                chance: 80,
                result: 1.25,
                maxChance: 95,
                minChance: 1,
                min: 799999,
                max: 200000,
                game: {
                    hash: '',
                    hid: ''
                },
                errors: {
                    show: false,
                    message: ''
                },
                success: {
                    show: false,
                    message: ''
                },
                disableBtn: false,
                myGames: [],
            }
        },
        mounted() {
            this.initGame();
            // this.getHash();
        },
		computed: {
			...mapState(useUserStore, ['user'])
		},
        methods: {
            initGame() {
                if(this.user) {
                    this.maxChance = +this.user.game_rules.dice_max_chance;
                }

                this.$root.isLoading = false;
            },
            validateBet() {
                if(typeof this.bet === 'string') {
                    this.bet = this.bet.replace(',', '.');
                }

				if (this.bet > 1000000) {
					this.bet = 1000000;
				}

				if (this.user && this.user.balance < this.bet) {
					this.bet = this.user.balance;
				}

                if (this.bet.length && !isNaN(this.bet) && this.bet < 1) {
                    this.bet = 1;
                }

                this.resultSize();
            },
            validateChance() {
                if(typeof this.chance === 'string') {
                    this.chance = this.chance.replace(',', '.');
                }

                if (this.chance > this.maxChance) {
                    this.chance = this.maxChance;
                }

                if (this.chance.length && !isNaN(this.chance) && this.chance < this.minChance) {
                    this.chance = this.minChance;
                }
  
                this.resultSize();
            },
            resultSize() {
				if (this.bet > 1000000) {
					this.bet = 1000000;
				}

				if (this.user && this.user.balance < this.bet) {
					this.bet = this.user.balance;
				}

                this.result = (parseFloat(((100 / parseFloat(this.chance)) * parseFloat(this.bet)) * 100))/100;

                if(isNaN(this.result)) {
                    this.result = '';
                } else {
                    this.result = this.result.toFixed(2);
                }
  
                this.min = Math.floor((this.chance / 100) * 999999);
                this.max = 999999 - Math.floor((this.chance / 100) * 999999);
            },
            typeBet(type) {
                switch (type) {
                    case "max":
                        if (this.user !== null) {
                            this.bet = this.user.balance;
                        } else {
                            this.bet = 0;
                        }
                        break;
                    case "min":
                        this.bet = 1;
                        break;
                    case "x2":
                        this.bet = this?.user?.balance && this.bet * 2 > +this.user.balance ? this.user.balance : (this.bet * 2).toFixed(2);
                        break;
                    case "/2":
                        this.bet = (this.bet / 2).toFixed(2);
                        break;
                }

                this.validateBet();
                this.resultSize();
            },
            typeChance(type) {
                let newChance;

                switch (type) {
                    case "max":
                        this.chance = this.maxChance;
                        break;
                    case "min":
                        this.chance = this.minChance;
                        break;
                    case "x2":
                        newChance = (this.chance * 2).toFixed(2);
                        this.chance = newChance > this.maxChance ? this.maxChance : newChance;
                        break;
                    case "/2":
                        newChance = (this.chance / 2).toFixed(2);
                        this.chance = newChance < this.minChance ? this.minChance : newChance;
                        break;
                }

                this.validateChance();
                this.resultSize();
            },
            betDiceSocket(type) {
                switch (type) {
                    case "max":
                        this.betType = 1;
                    break;
                    case "min":
                        this.betType = 0;
                    break;
                }
                this.errors.show = false;
                this.success.show = false;
                this.disableBtn = true;

                if (!this.$cookie.get('token')) {
                    this.errors = {
                        show: true,
                        message: 'Авторизуйтесь'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (this.user && this.bet > this.user.balance) {
                    this.errors = {
                        show: true,
                        message: 'Средств на вашем балансе недостаточно'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (isNaN(this.bet)) {
                    this.errors = {
                        show: true,
                        message: 'Введите число'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (this.bet.length === 0) {
                    this.errors = {
                        show: true,
                        message: 'Введите ставку'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (this.chance.length === 0) {
                    this.errors = {
                        show: true,
                        message: 'Введите шанс'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (isNaN(this.chance)) {
                    this.errors = {
                        show: true,
                        message: 'Шанс должен быть числом от ' + this.minChance + ' до ' + this.maxChance
                    };

                    this.chance = this.maxChance;

                    this.disableBtn = false;

                    return;
                }

                if (this.chance > this.maxChance) {
                    this.errors = {
                        show: true,
                        message: 'Максимальный шанс ' + this.maxChance
                    };

                    this.chance = this.maxChance;

                    this.disableBtn = false;

                    return;
                }

                if (this.chance < this.minChance) {
                    this.errors = {
                        show: true,
                        message: 'Минимальный шанс ' + this.minChance
                    };

                    this.chance = this.minChance;

                    this.disableBtn = false;

                    return;
                }
                
                this.$root.axios.post('/api/game/dice/play', {
                    side: this.betType,
                    bet: this.bet,
                    chance: this.chance
                }).then(res => {
                    const data = res.data;

                    this.user.balance = data.balance;

                    if (data.winner) {
                        this.success = {
                            show: true,
                            message: data.message
                        };
                    } else {
                        this.errors = {
                            show: true,
                            message: data.message
                        };
                    }

                    if (data.wager <= 0) {
                        this.initGame();
                    }

                    this.disableBtn = false;
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };

                    this.disableBtn = false;
                });
            },
            addMyHistory(bet) {
                if (this.myGames.length >= 20) {
                    this.myGames.pop();
                }

                this.myGames.unshift({
                    game: 'dice',
                    id: bet.id,
                    username: this.user.username,
                    bet: bet.bet,
                    chance: bet.chance,
                    win: bet.win
                });
            }
        }
    }
</script>
